import { render } from "./ProfileChangePassword.vue?vue&type=template&id=4dcf63ba&scoped=true&ts=true&lang=pug"
import script from "./ProfileChangePassword.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileChangePassword.vue?vue&type=script&lang=ts&setup=true"

import "./ProfileChangePassword.vue?vue&type=style&index=0&id=4dcf63ba&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dcf63ba"]])

export default __exports__